import React, { FunctionComponent } from 'react';

const CloseIcon: FunctionComponent = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2L20 20M2 20L20 2" stroke="#19194A" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export default CloseIcon;
